import React from 'react';
import StateSocialWorkerJobsPage from './StateSocialWorkerJobsPage';

const CaliforniaSocialWorkerJobs = () => {
  return (
    <StateSocialWorkerJobsPage
      stateName="California"
      stateAbbr="CA"
      metaTitle="California Social Worker Jobs (LMSW, LCSW, MSW) | INeedASocialWorker"
      metaDescription="Find California social worker jobs in hospitals, hospice, schools, behavioral health, and community agencies. Search Los Angeles, San Francisco, San Diego jobs. Apply fast."
      cities={[
        "Los Angeles",
        "San Francisco",
        "San Diego",
        "Sacramento",
        "San Jose",
        "Oakland",
        "Fresno",
        "Long Beach",
        "Bakersfield",
        "Anaheim",
        "Santa Ana",
        "Riverside",
        "Irvine"
      ]}
      stateDescription="Looking for social work jobs in California? The Golden State offers abundant opportunities in behavioral health, community services, hospitals, and school districts across major metropolitan areas."
      faqItems={[
        {
          question: "What types of social work jobs are hiring in California right now?",
          answer: "California employers commonly hire for hospital/medical social work, behavioral health, school-based services, community mental health, and child welfare roles. Los Angeles and the Bay Area have the highest concentration of positions."
        },
        {
          question: "What license do I need to practice social work in California?",
          answer: "California requires the LCSW (Licensed Clinical Social Worker) for independent clinical practice. The ASW (Associate Social Worker) designation is for those completing supervised experience. California also has the LMSW for non-clinical practice."
        },
        {
          question: "What is the average salary for social workers in California?",
          answer: "California social workers earn among the highest salaries nationwide, typically ranging from $55,000-$90,000+ depending on setting, experience, and location. Bay Area and Southern California metros often offer premium compensation."
        },
        {
          question: "How do I apply faster?",
          answer: "Create your profile, upload your resume, and use one-click apply when available through our SW Express Apply™ feature."
        }
      ]}
    />
  );
};

export default CaliforniaSocialWorkerJobs;
